import {isOn} from '../../lib/flags';
import HasAdminRole from '../../security/rules/HasAdminRole';
import HasManagementRole from '../../security/rules/HasManagementRole';

export const INVENTORY_FLAG = 'INVENTORY_ENABLED';

//Managers and admins can view inventory, but only while the company has inventory turned on
export function canViewInventory(user) {
  return !!user && !!isOn(user, INVENTORY_FLAG) && HasManagementRole(user);
}

//Adjustments are admin only. The api enforces this too; this just hides the controls
export function canAdjustInventory(user) {
  return canViewInventory(user) && HasAdminRole(user);
}
